// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__3S9uF","heroVideo":"hero_heroVideo__3ZUjl","overlay":"hero_overlay__2ayYW","heading":"hero_heading__15C20","button":"hero_button__3gsLK","icon":"hero_icon__3CvPE"};